module.exports = __webpack_public_path__ + "static/media/tq6.f819393a.jpg";